<template>
  <div :class="['obj-major-info-content perf-info', perfCls]">
    <div class="title-bar">
      <span class="title mr-r10">성능정보</span>
      <span class="sub-label">최근12시간</span>
    </div>
    <el-carousel :class="perfCls" :interval="10000" trigger="click" height="106px" arrow="never" :indicator-position="perfInfo.length > 1 ? 'outside' : 'none'" :autoplay="true">
      <el-carousel-item class="" v-for="(item, index) in carousel" :key="item">
        <div class="chart-wrapper">
          <w-perf-view ref="chartView" :class="chartCls" v-for="(perf, idx) in chartItem(index)" :key="idx" :chart-data="perf" :name-list="nameList(index)" :idx="idx" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import WPerfView from '@/views/topologymap/components/major-info/components/PerfView';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WManagedObjectPerfInfoView',
  components: {
    WPerfView,
  },
  data() {
    return {
      perfInfo: [],
      objDefineId: '',
      objtypeId: '',
      rscNameList: [],
    };
  },
  computed: {
    carousel() {
      return (isEmpty(this.perfInfo) || this.perfInfo.length <= 3) ? 1 : Math.floor(this.perfInfo.length / 3);
    },
    /**
     * 차트 class
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    chartCls() {
      let count = '';
      if (this.objtypeId === 'FVA' || this.objtypeId === 'FTHEHYGRO' || this.objtypeId === 'FTH') {
        count = 'two';
      } else if (this.objtypeId === 'FWLDS' || this.objtypeId === 'FSENSOR' || this.objtypeId === 'FAIRFLOW' || this.objtypeId === 'FNSDS' || this.objtypeId === 'VDS' || this.objtypeId === 'VDSC') {
        count = 'one';
      } else {
        count = 'three';
      }
      return `${count}-item`;
    },
    /**
     * 분할해서 표현 할 차트 item list 반환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    chartItem() {
      const me = this;
      return (index) => {
        let chartData = [];
        if (!isEmpty(me.perfInfo)) {
          let cnt = 0;
          if (me.objtypeId === 'FVA' || me.objtypeId === 'FTHEHYGRO' || me.objtypeId === 'FTH') {
            cnt = 2;
          } else if (me.objtypeId === 'FWLDS' || me.objtypeId === 'FSENSOR' || me.objtypeId === 'FAIRFLOW' || me.objtypeId === 'FNSDS') {
            cnt = 1;
          } else {
            cnt = 3;
          }
          const start = index * cnt;
          const end = start + cnt;
          chartData = me.perfInfo.slice(start, end);
        }

        return chartData;
      };
    },
    /**
     * 분할해서 표현 할 차트 라벨 list 반환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    nameList() {
      const me = this;
      return (index) => {
        let name = [];
        if (!isEmpty(me.perfInfo)) {
          let cnt = 0;
          if (me.objtypeId === 'FVA' || me.objtypeId === 'FTHEHYGRO' || me.objtypeId === 'FTH') {
            cnt = 2;
          } else if (me.objtypeId === 'FWLDS' || me.objtypeId === 'FSENSOR' || me.objtypeId === 'FAIRFLOW' || me.objtypeId === 'FNSDS') {
            cnt = 1;
          } else {
            cnt = 3;
          }
          const start = index * cnt;
          const end = start + cnt;
          name = me.rscNameList.slice(start, end);
        }

        return name;
      };
    },
    /**
     * 차트 자원수에 따른 class
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    perfCls() {
      return this.carousel === 1 ? 'single' : 'multi';
    },
  },
  methods: {
    /**
     * 데이터 초기화 (요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} data        [description]
     * @param  {[type]} objDefineId [description]
     * @param  {[type]} objtypeId   [description]
     * @param  {[type]} rscNameList [description]
     */
    setData(data, objDefineId, objtypeId, rscNameList) {
      this.perfInfo = data;
      this.objDefineId = objDefineId;
      this.objtypeId = objtypeId;
      if (objtypeId === 'FTEMP' || objtypeId === 'FADC' || objtypeId === 'FVA' || objtypeId === 'FCM') {
        this.rscNameList = this.getRscNameList();
      } else {
        this.rscNameList = rscNameList;
      }
    },
    /**
     * 데이터 초기화 (기본값)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.perfInfo = [];
      this.objDefineId = '';
      this.rscNameList = [];
    },
    /**
     * 차트 라벨 리스트 가공
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    getRscNameList() {
      const rscNameList = [];

      this.perfInfo.forEach((perf) => {
        rscNameList.push(isEmpty(perf.hist) ? '' : perf.hist[0].name);
      });
      return rscNameList;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/ManagedObjectPerfInfoView.vue